import cn from 'classnames';

import googlePowerImg from './assets/powered-by-google-white.png';
import { MagnifierIcon } from 'shared/icons/MagnifierIcon';
import { AutocompleteData, AutocompleteSuggestion } from '@/domain';

import styles from './AutocompleteList.module.css';

export type AutocompleteListProps = {
    data: AutocompleteData;
    width: number;
    focused: number;
    handleSelection: (item: AutocompleteSuggestion) => void;
    setFocus: (idx: number) => void;
};
export const AutocompleteList = (props: AutocompleteListProps) => {
    const rows = props.data.suggestions
        ? props.data.suggestions.map((item, i) =>
              item.type === 'search' ? (
                  <li
                      key={`fhh-search-suggestion-${i}`}
                      role="option"
                      aria-selected={i === props.focused ? 'true' : 'false'}
                      id={`fhh-search-suggestion-${i}`}
                      className={`p-8 cursor-pointer ${i === props.focused && item.numResults !== 0 ? 'bg-green-200' : 'bg-white'}`}
                      onClick={() => props.handleSelection(item)}
                      onMouseEnter={() => props.setFocus(i)}
                      data-query={item.query}
                      data-testid={`autocomplete-query-${item.query}`}>
                      <div className="flex justify-between items-center">
                          <span>
                              <MagnifierIcon />
                              <span>
                                  Søk etter <span className="font-bold">{item.query}</span> i annonsene
                              </span>
                          </span>
                          <span className="text-14 whitespace-nowrap" data-testid="fhh-freetext-search-suggestion">
                              ({item.numResults} &nbsp;treff)
                          </span>
                      </div>
                  </li>
              ) : (
                  <li
                      key={`fhh-search-suggestion-${i}`}
                      role="option"
                      aria-selected={i === props.focused ? 'true' : 'false'}
                      id={`fhh-search-suggestion-${i}`}
                      className={`cursor-pointer p-8 ${i === props.focused ? 'bg-green-200' : 'bg-white'}`}
                      onClick={() => props.handleSelection(item)}
                      onMouseEnter={() => props.setFocus(i)}
                      data-testid={`fhh-search-suggestion-location-${item.primary}`}
                      data-location={item.primary}>
                      <div className="flex justify-between items-center">
                          <span>
                              <span className="font-bold pr-4">{item.primary}</span>
                              <span>{item.secondary}</span>
                          </span>
                          <span className="text-14 whitespace-nowrap">{item.numResults > 0 ? `(${item.numResults} treff)` : null}</span>
                      </div>
                  </li>
              )
          )
        : [];

    const googlePower = (
        <li key="google" className="bg-white text-gray-500 p-8">
            <img
                className={styles.googleImg}
                src={googlePowerImg.src}
                width={googlePowerImg.width}
                height={googlePowerImg.height}
                alt="Powered by Google"
                aria-hidden
                data-testid="googleLogo"
            />
        </li>
    );

    rows.splice(-1, 0, googlePower);

    return (
        <div
            className={cn(styles.autocompleteList, { hidden: !props.data.showSuggestions })}
            style={{ width: `${props.width}px` }}
            data-testid="Autocomplete-list">
            <div className="suggestion-dropdown shadow-2 rounded-8 py-8 bg-white mt-0">
                <ul id="fhh-search-suggestions" role="listbox">
                    {rows}
                </ul>
            </div>
        </div>
    );
};
